import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=76c5c6bc&"
import script from "./IconRight.vue?vue&type=script&lang=js&"
export * from "./IconRight.vue?vue&type=script&lang=js&"
import style0 from "./IconRight.vue?vue&type=style&index=0&id=76c5c6bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports